// list of applicable user permissions in the system
export enum UserPermissionEnum {
  // can change a user's assigned role
  AssignRole = 'assignRole',
  // can remove a user from an organization
  RemoveUser = 'removeUser',
  // can transfer content (bookmark) ownership
  TransferContent = 'transferContent',
  // can create a collection
  CreateCollection = 'createCollection',
  // can delete a collection
  DeleteCollection = 'deleteCollection',
  // can edit team account (i.e., manage)
  EditTeamAccount = 'editTeamAccount',
  // can edit any team bookmark with edit accesss
  EditTeamBookmarks = 'editTeamBookmarks',
  // can edit (and manage) all team bookmarks
  EditAllTeamBookmarks = 'editAllTeamBookmarks',
  // can add content to team's dashboard (including collections)
  AddTeamBookmarks = 'addTeamBookmarks',
  // can remove content to team's dashboard (including collections)
  RemoveTeamBookmarks = 'removeTeamBookmarks',
  // can edit dashboard content
  EditBookmarks = 'editBookmarks',
  // can publish bookmarks
  PublishBookmarks = 'publishBookmarks',
  // can save private bookmarks
  SavePrivateBookmarks = 'savePrivateBookmarks',
  // can copy URLs
  CopyUrl = 'copyURL',
  // can view
  ViewBookmarks = 'viewBookmarks',
  // can invite users
  InviteUsers = 'inviteUsers',
  // can export CSV
  ExportCSV = 'exportCSV',
}
